import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

const AdminLogin = () => {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="min-h-screen bg-[var(--bg-primary)] flex items-center justify-center"><div className="text-[var(--text-secondary)]">Loading...</div></div>;
  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <img src="/logo-rc.png" alt="RC" className="h-16 w-auto mx-auto mb-4" data-testid="admin-login-logo" />
          <h1 className="font-brand text-xl uppercase tracking-[0.2em] text-white mb-2">Raulvin Coke</h1>
          <p className="text-sm text-[var(--accent-violet-light)]">Intelligence Desk</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-[var(--bg-card)] border-glow rounded-xl p-8 space-y-5">
          {error && <p className="text-red-400 text-sm bg-red-400/10 rounded-lg px-4 py-2" data-testid="login-error">{error}</p>}
          <div>
            <label className="text-xs text-[var(--text-secondary)] uppercase tracking-wider mb-1.5 block">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full px-4 py-3 bg-[var(--bg-secondary)] border border-[rgba(124,58,237,0.15)] rounded-lg text-white placeholder:text-[var(--text-secondary)] focus:border-[var(--accent-violet)] focus:outline-none" data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs text-[var(--text-secondary)] uppercase tracking-wider mb-1.5 block">Password</label>
            <div className="relative">
              <input type={showPw ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full px-4 py-3 bg-[var(--bg-secondary)] border border-[rgba(124,58,237,0.15)] rounded-lg text-white focus:border-[var(--accent-violet)] focus:outline-none pr-12" data-testid="login-password" />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--text-secondary)]">
                {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <button type="submit" disabled={submitting} className="w-full bg-[var(--accent-violet)] hover:bg-[#6d28d9] text-white py-3 rounded-lg font-semibold transition-all disabled:opacity-60" data-testid="login-submit">
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
